import React, {
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import styled from "styled-components";

import ShipmentReportResult from "./ShipmentReportResult";
import { ShipmentListTable } from "./ShipmentListTable";
import {
  Title,
  SearchHeader,
  SearchCard,
} from "./ReportComponents";

const StyledInputGroupAddon = styled(InputGroupAddon)`
  cursor: pointer;
  background-color: #2484c6;
  border-radius: 5px;
  &:hover {
    background-color: #1a669a;
  };
`;

const ShipmentReport = () => {
  const [code, setCode] = useState("");
  const [searchShipment, setSearchShipment] = useState(false);

  const handleChange = useCallback(({ target: { value } }) => {
    setCode(value);
    setSearchShipment(false);
  }, []);

  const triggerSearch = () => {
    setSearchShipment(true);
  };

  return (
    <div className="content p-0">
      <div
        style={{
          padding: "0",
          width: "80%",
          margin: "0 auto",
        }}
      >
        <Row>
          <Col>
            <SearchCard>
              <SearchHeader>
                <Title>Buscar por código:</Title>

                <InputGroup
                  className="no-border"
                  style={{ marginBottom: 0, marginRight: 10 }}
                >
                  <Input
                    value={code}
                    onChange={handleChange}
                    type="text"
                  />

                  <StyledInputGroupAddon
                    addonType="append"
                    onClick={() => triggerSearch()}
                  >
                    <InputGroupText>
                      <i className="nc-icon nc-zoom-split" style={{ color: "#fff", fontWeight: 900 }} />
                    </InputGroupText>
                  </StyledInputGroupAddon>
                </InputGroup>

              </SearchHeader>
            </SearchCard>
          </Col>
        </Row>
        {searchShipment && (
          <ShipmentReportResult code={code} />
        )}
      </div>
      {!code && (
        <ShipmentListTable />
      )}
    </div>
  );
};

export default ShipmentReport;
